interface FilterSidebarProps {
  years: string[];
  tags: string[];
  duration: string;
  year: string;
  tag: string;
  showDuration: boolean;
  onDuration: (value: string) => void;
  onYear: (value: string) => void;
  onTag: (value: string) => void;
  onReset: () => void;
}

const DURATION_OPTIONS = [
  { value: "all", label: "全部时长" },
  { value: "short", label: "3分钟以内" },
  { value: "medium", label: "3 - 5分钟" },
  { value: "long", label: "5分钟以上" },
];

function OptionButton({
  active,
  label,
  onClick,
}: {
  active: boolean;
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors whitespace-nowrap ${
        active
          ? "bg-primary-500 text-background-50"
          : "bg-background-100 text-foreground-700 hover:bg-background-200"
      }`}
    >
      {label}
    </button>
  );
}

export default function FilterSidebar({
  years,
  tags,
  duration,
  year,
  tag,
  showDuration,
  onDuration,
  onYear,
  onTag,
  onReset,
}: FilterSidebarProps) {
  return (
    <div className="flex flex-col gap-7">
      <div className="flex items-center justify-between">
        <h3 className="font-heading font-semibold text-sm text-foreground-950 flex items-center gap-2">
          <i className="ri-filter-3-line text-primary-500" />
          筛选条件
        </h3>
        <button
          type="button"
          onClick={onReset}
          className="text-xs text-foreground-500 hover:text-primary-600 flex items-center gap-1"
        >
          <i className="ri-refresh-line" />
          重置
        </button>
      </div>

      {showDuration && (
        <div>
          <p className="text-xs font-medium text-foreground-500 mb-3">视频时长</p>
          <div className="flex flex-wrap gap-2">
            {DURATION_OPTIONS.map((opt) => (
              <OptionButton
                key={opt.value}
                label={opt.label}
                active={duration === opt.value}
                onClick={() => onDuration(opt.value)}
              />
            ))}
          </div>
        </div>
      )}

      <div>
        <p className="text-xs font-medium text-foreground-500 mb-3">发布年份</p>
        <div className="flex flex-wrap gap-2">
          <OptionButton label="全部年份" active={year === "all"} onClick={() => onYear("all")} />
          {years.map((y) => (
            <OptionButton key={y} label={y} active={year === y} onClick={() => onYear(y)} />
          ))}
        </div>
      </div>

      <div>
        <p className="text-xs font-medium text-foreground-500 mb-3">热门标签</p>
        <div className="flex flex-wrap gap-2">
          <OptionButton label="全部标签" active={tag === "all"} onClick={() => onTag("all")} />
          {tags.map((t) => (
            <OptionButton key={t} label={t} active={tag === t} onClick={() => onTag(t)} />
          ))}
        </div>
      </div>
    </div>
  );
}